<template>
  <div class="qc-card shadow mx-auto">
    <div class="qc-logo text-center">
      <img class="img-fluid" :src="logoUrl" alt="logo" />
    </div>
    <h4 class="text-center pb-4 ">
      {{
        this.identity == "manage"
          ? "管理者登入"
          : this.identity == "cms"
          ? "廠商登入"
          : "會員登入"
      }}
    </h4>
    <b-form @submit.stop.prevent="onSubmit">
      <b-form-group id="input-group-2" label="手機號碼" label-for="input-2">
        <b-form-input
          id="input-2"
          class="rounded-0"
          type="tel"
          v-model="form.telephone"
          :state="verification_tel"
          required
          placeholder="請輸入手機號碼"
          @keydown.enter="node_env"
          ref="telephone"
        ></b-form-input>
        <b-form-invalid-feedback :state="verification_tel">
          請輸入正確的手機號碼
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button
        block
        squared
        :variant="identity + '_sub'"
        class="mb-3 text-white"
        :disabled="sendBtnIsDisabled"
        @click="node_env"
        >{{
          verification_tel
            ? "重新傳送驗證碼 " +
              (sendBtnIsDisabled && minutes_to_send != 0
                ? minutes_to_send + " 分"
                : "") +
              (sendBtnIsDisabled && seconds_to_send != 0
                ? " " + seconds_to_send + " 秒"
                : "")
            : "傳送驗證碼"
        }}
      </b-button>
      <div
        class="text-center text-danger mb-4"
        style="font-size: 14px;"
        v-if="authError"
      >
        {{ authText }}
        <br />
        {{
          authText == "嘗試次數過多，請等候30秒再重新傳送驗證碼"
            ? ""
            : "請檢查是否填寫正確，再重新輸入一次"
        }}
      </div>
      <div
        class="text-center text-danger mb-4"
        style="font-size: 14px;"
        v-if="verification_tel && sendBtnIsDisabled"
      >
        驗證碼將以簡訊方式傳送到您的手機 <br />
        請注意查收 ({{ effective_time }}內有效)
      </div>
      <b-form-group
        v-if="verification_tel"
        id="input-group-2"
        label="驗證碼"
        label-for="input-2"
      >
        <b-form-input
          id="input-2"
          class="rounded-0"
          type="text"
          v-model="form.authCode"
          :state="verification_code"
          :required="verification_tel"
          placeholder="請輸入驗證碼"
          ref="authCode"
        ></b-form-input>
        <b-form-invalid-feedback :state="verification_code">
          {{ verification_text }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button
        v-if="verification_tel"
        block
        squared
        class="mb-3"
        :variant="identity + '_main'"
        type="submit"
        :disabled="!verification_tel"
        >登入</b-button
      >
      <div class="text-right " v-if="this.identity == 'platform'">
        <b-link href="/register" class="text-platform_main"
          >還不是會員？</b-link
        >
      </div>
    </b-form>
    <vue-recaptcha
      ref="recaptcha"
      :sitekey="sitekey"
      @verify="onCaptchaVerified"
      @expired="onCaptchaExpired"
      size="invisible"
      :loadRecaptchaScript="true"
    ></vue-recaptcha>
  </div>
</template>

<style lang="scss">
.qc {
  &-card {
    width: 90%;
    padding: 30px;
    background-color: #fff;
  }
}
</style>

<script>
import { LoginManage } from "@/assets/api/manage.js";
import { LoginCms } from "@/assets/api/cms.js";
import { LoginPlatform } from "@/assets/api/platform.js";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "Login",
  props: ["identity"],
  components: { VueRecaptcha },
  data() {
    return {
      form: {
        telephone: "",
        authID: "",
        authCode: ""
      },
      sitekey: "6LfiSZUaAAAAANjYYoB3Im-U8qvQQX-ad39h8cea",
      google_recaptcha_token: null,
      verification_tel: null,
      verification_code: null,
      verification_text: null,
      sendBtnIsDisabled: false,
      seconds_to_send: 0,
      minutes_to_send: 0,
      effective_time: "",
      authError: false,
      authText: ""
    };
  },
  created() {
    this.verification_code = null;
    this.effective_time = Number(process.env.VUE_APP_MINUTES_TO_SEND_SMS || 0)
      ? process.env.VUE_APP_MINUTES_TO_SEND_SMS + " 分鐘"
      : "";
    this.effective_time += Number(process.env.VUE_APP_SECONDS_TO_SEND_SMS || 30)
      ? (process.env.VUE_APP_SECONDS_TO_SEND_SMS || 30) + " 秒"
      : "";
    this.seconds_to_send = Number(
      process.env.VUE_APP_SECONDS_TO_SEND_SMS || 30
    );
    this.minutes_to_send = Number(process.env.VUE_APP_MINUTES_TO_SEND_SMS || 0);
  },
  computed: {
    logoUrl() {
      if (this.identity == "manage") {
        return require("@/assets/image/quartercar-logo.svg");
      } else if (this.identity == "cms") {
        return require("@/assets/image/quartercar-logo_green.svg");
      } else {
        return require("@/assets/image/quartercar-logo_red.svg");
      }
    }
  },
  watch: {
    "form.telephone": function(val) {
      if (val) {
        this.verification_code = null;
        this.verification_text = null;
        this.sendBtnIsDisabled = false;
      }
    }
  },
  methods: {
    node_env() {
      this.authError = false;
      this.sendCountdownTime();
      // process.env.NODE_ENV === "development"
      //   ? this.sendCountdownTime()
      //   : this.executeRecaptcha();
    },
    executeRecaptcha() {
      this.$refs.recaptcha.execute();
    },
    sendCountdownTime() {
      let data = {};
      if (!process.env.NODE_ENV === "development") {
        this.$refs.recaptcha.reset();
        data = {
          telephone: this.form.telephone,
          google_recaptcha_token: this.google_recaptcha_token
        };
      } else {
        data = {
          telephone: this.form.telephone,
          google_recaptcha_token: "test"
        };
      }
      if (
        this.form.telephone == "" ||
        !/^09[0-9]{8}$/.test(this.form.telephone)
      ) {
        this.verification_tel = false;
        return;
      }
      this.verification_tel = null;
      this.verification_code = null;
      this.verification_text = null;
      this.authError = false;

      switch (this.identity) {
        case "manage":
          LoginManage.login(data)
            .then(res => {
              if (res.status <= 201) {
                this.form.authCode = res.data.authCode || "";
                this.form.authID = res.data.authID;
                this.verification_tel = true;
                this.sendBtnIsDisabled = true;
                this.seconds_to_send = Number(
                  process.env.VUE_APP_SECONDS_TO_SEND_SMS || 30
                );
                this.minutes_to_send = Number(
                  process.env.VUE_APP_MINUTES_TO_SEND_SMS || 0
                );
                let countdown = setInterval(() => {
                  if (this.seconds_to_send == 1 && this.minutes_to_send == 0) {
                    clearTimeout(countdown);
                    this.sendBtnIsDisabled = false;
                  } else if (this.seconds_to_send == 0) {
                    this.minutes_to_send -= 1;
                    this.seconds_to_send = 60;
                  }
                  this.seconds_to_send -= 1;
                }, 1000);
                this.$nextTick(() => {
                  this.$refs.authCode.focus();
                });
              } else {
                this.authError = true;
                if (res.data.error == "Account Not Found") {
                  this.authText = "找無此號碼";
                } else if (res.data.error == "嘗試次數過多") {
                  this.authText = "嘗試次數過多，請等候30秒再重新傳送驗證碼";
                } else {
                  this.authText = res.status + " ";
                  this.authText += res.data.error;
                }
              }
            })
            .catch(err => {
              this.authError = true;
              this.authText = err;
            });
          break;
        case "cms":
          LoginCms.login(data)
            .then(res => {
              if (res.status <= 201) {
                this.form.authCode = res.data.authCode || "";

                this.form.authID = res.data.authID;
                this.verification_tel = true;
                this.sendBtnIsDisabled = true;
                this.seconds_to_send = Number(
                  process.env.VUE_APP_SECONDS_TO_SEND_SMS || 30
                );
                this.minutes_to_send = Number(
                  process.env.VUE_APP_MINUTES_TO_SEND_SMS || 0
                );
                let countdown = setInterval(() => {
                  if (this.seconds_to_send == 1 && this.minutes_to_send == 0) {
                    clearTimeout(countdown);
                    this.sendBtnIsDisabled = false;
                  } else if (this.seconds_to_send == 0) {
                    this.minutes_to_send -= 1;
                    this.seconds_to_send = 60;
                  }
                  this.seconds_to_send -= 1;
                }, 1000);
                this.$nextTick(() => {
                  this.$refs.authCode.focus();
                });
              } else {
                this.authError = true;
                if (res.data.error == "Account Not Found") {
                  this.authText = "找無此號碼";
                } else if (res.data.error == "嘗試次數過多") {
                  this.authText = "嘗試次數過多，請等候30秒再重新傳送驗證碼";
                } else {
                  this.authText = res.status + " ";
                  this.authText += res.data.error;
                }
              }
            })
            .catch(err => {
              this.authError = true;
              this.authText = err;
            });
          break;
        case "platform":
          LoginPlatform.login(data)
            .then(res => {
              if (res.status <= 201) {
                this.form.authCode = res.data.authCode || "";
                this.form.authID = res.data.authID;
                this.verification_tel = true;
                this.sendBtnIsDisabled = true;
                this.seconds_to_send = Number(
                  process.env.VUE_APP_SECONDS_TO_SEND_SMS || 30
                );
                this.minutes_to_send = Number(
                  process.env.VUE_APP_MINUTES_TO_SEND_SMS || 0
                );
                let countdown = setInterval(() => {
                  if (this.seconds_to_send == 1 && this.minutes_to_send == 0) {
                    clearTimeout(countdown);
                    this.sendBtnIsDisabled = false;
                  } else if (this.seconds_to_send == 0) {
                    this.minutes_to_send -= 1;
                    this.seconds_to_send = 60;
                  }
                  this.seconds_to_send -= 1;
                }, 1000);
                this.$nextTick(() => {
                  this.$refs.authCode.focus();
                });
              } else {
                this.authError = true;
                if (res.data.error == "Account Not Found") {
                  this.authText = "找無此號碼";
                } else if (res.data.error == "嘗試次數過多") {
                  this.authText = "嘗試次數過多，請等候30秒再重新傳送驗證碼";
                } else {
                  this.authText = res.status + " ";
                  this.authText += res.data.error;
                }
              }
            })
            .catch(error => {
              this.authError = true;
              this.authText = error;
            });
          break;
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (!this.form.authCode) return;
      switch (this.identity) {
        case "manage":
          LoginManage.confirm(this.form)
            .then(res => {
              if (res.status <= 201) {
                localStorage.setItem("manage-api_token", res.data.api_token);
                this.$router.push({ name: "廠商帳號管理" });
              } else {
                this.verification_code = false;
                if (res.data.error == "Auth Failed") {
                  this.verification_text = "驗證失敗";
                } else {
                  this.verification_text = res.data.error;
                }
              }
            })
            .catch(err => {
              this.verification_code = false;
              this.verification_text = err;
            });
          break;
        case "cms":
          LoginCms.confirm(this.form)
            .then(res => {
              if (res.status <= 201) {
                localStorage.setItem("cms-api_token", res.data.api_token);
                const cmsToken = {
                  headers: {
                    Authorization: "Bearer " + res.data.api_token
                  }
                };
                LoginCms.permission(cmsToken)
                  .then(res => {
                    if (res.status <= 201) {
                      if (res.data.role[0] == "Admin") {
                        this.$router.push({ name: "商品管理" });
                      } else {
                        this.$router.push({ name: "訂單管理" });
                      }
                    } else {
                      this.verification_code = false;
                      this.verification_text = res.data.error;
                    }
                  })
                  .catch(err => {
                    this.verification_code = false;
                    this.verification_text = err;
                  });
              } else {
                this.verification_code = false;
                if (res.data.error == "Auth Failed") {
                  this.verification_text = "驗證失敗";
                } else {
                  this.verification_text = res.data.error;
                }
              }
            })
            .catch(err => {
              this.verification_code = false;
              this.verification_text = err;
            });
          break;
        case "platform":
          LoginPlatform.confirm(this.form)
            .then(res => {
              if (res.status <= 201) {
                localStorage.setItem("platform-api_token", res.data.api_token);
                this.$router.push({ name: "首頁" });
              } else {
                this.verification_code = false;
                if (res.data.error == "Auth Failed") {
                  this.verification_text = "驗證失敗";
                } else {
                  this.verification_text = res.data.error;
                }
              }
            })
            .catch(err => {
              this.verification_code = false;
              this.verification_text = err;
            });
          break;
      }
    },
    onCaptchaVerified(token) {
      this.google_recaptcha_token = token;
      this.sendCountdownTime();
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    }
  },
  mounted() {
    this.$refs.telephone.focus();
  }
};
</script>
